import es from 'vuejs-datepicker/dist/locale/translations/es';

const EstadosCiviles = [
    {id: 1, label:'Soltera (o)'} ,
    {id: 2, label:'Casada (o)'} ,
    {id: 3, label:'Divorciada (o)'} ,
    {id: 4, label:'Union Libre'} ,
    {id: 5, label:'Viuda (o)'} ,
    {id: 6, label:'Concubinato'} ,
];

const Genero = [
    {id: 1, label:'Femenino'} ,
    {id: 2, label:'Masculino'} ,
];

const Equipo = [
    {id: 1, label:'Vehículo'} ,
    {id: 2, label:'Teléfono'} ,
    {id: 3, label:'Linea Telefonica'} ,
];

const calendarSettings = {
    Style: 'form-control',
    Formato: 'yyyy-MM-dd',
    Idioma: es,
    DisabledDates: {
        to: new Date(Date.now() - 8640000)
    }
}


export default {
    EstadosCiviles,
    Genero,
    Equipo,
    calendarSettings,
};
